import { hotItems } from '@/mocks/hot';

const trendIcon: Record<string, { cls: string; icon: string }> = {
  up: { cls: 'text-accent-600', icon: 'ri-arrow-up-line' },
  down: { cls: 'text-primary-400', icon: 'ri-arrow-down-line' },
  new: { cls: 'text-secondary-600', icon: 'ri-sparkling-2-line' },
  flat: { cls: 'text-background-300', icon: 'ri-arrow-right-line' },
};

function numStyle(i: number) {
  if (i === 0) return 'text-accent-600';
  if (i === 1) return 'text-primary-500';
  if (i === 2) return 'text-secondary-600';
  return 'text-background-300';
}

export default function HotSection() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700 ring-1 ring-accent-200">
              <i className="ri-fire-line" />
              全网热榜
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">今天滚烫的话题都在这里</h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              榜单综合全网讨论量与增速实时排序，数字越大代表此刻越"燃"，随时刷新看看什么正在登顶。
            </p>
          </div>
          <div className="flex items-center gap-5 text-xs text-foreground-500">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-arrow-up-line text-accent-600" /> 上升
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-arrow-down-line text-primary-400" /> 下降
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-sparkling-2-line text-secondary-600" /> 新上榜
            </span>
          </div>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-background-200/80 bg-background-100/60">
          <ul className="divide-y divide-background-200/60">
            {hotItems.map((it, i) => {
              const t = trendIcon[it.trend];
              return (
                <li key={it.id}>
                  <a
                    href="#feed"
                    className="group flex items-center gap-4 px-4 py-3.5 transition hover:bg-background-50 md:gap-6 md:px-6"
                  >
                    <span className={`w-7 shrink-0 text-center font-heading text-3xl leading-none ${numStyle(i)}`}>
                      {i + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-2">
                        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700 md:text-base">
                          {it.title}
                        </h3>
                        <span
                          className={`hidden shrink-0 items-center gap-0.5 rounded-md px-1.5 py-0.5 text-[11px] font-semibold sm:inline-flex ${t.cls} bg-background-50`}
                        >
                          <i className={t.icon} />
                          {it.trend === 'new' ? '新上榜' : it.trend === 'up' ? '上升' : it.trend === 'down' ? '下降' : '持平'}
                        </span>
                      </div>
                      <p className="mt-1 hidden truncate text-xs text-foreground-500 sm:block">{it.desc}</p>
                      <div className="mt-2 hidden h-1 w-full max-w-xs overflow-hidden rounded-full bg-background-200/70 md:block">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-secondary-400 via-primary-500 to-accent-500"
                          style={{ width: `${it.bar}%` }}
                        />
                      </div>
                    </div>
                    <div className="flex shrink-0 flex-col items-end gap-1">
                      <span className="inline-flex items-center gap-1 rounded-full bg-accent-50 px-2.5 py-1 text-xs font-bold text-accent-700">
                        <i className="ri-fire-fill" style={{ fontSize: 12 }} />
                        {it.heat}
                      </span>
                      <span className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-500">
                        {it.tag}
                      </span>
                    </div>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}